const checklistsTypes = {
  FETCHING_FRANCHISES: 'FETCHING_FRANCHISES',
  FRANCHISES_FETCHED: 'FRANCHISES_FETCHED',
  ERROR_FETCHING_FRANCHISES: 'ERROR_FETCHING_FRANCHISES',

  FETCHING_PAST_CHECKLISTS: 'FETCHING_PAST_CHECKLISTS',
  PAST_CHECKLISTS_FETCHED: 'PAST_CHECKLISTS_FETCHED',
  ERROR_FETCHING_PAST_CHECKLISTS: 'ERROR_FETCHING_PAST_CHECKLISTS',

  FETCHING_USERS: 'FETCHING_USERS',
  USERS_FETCHED: 'USERS_FETCHED',
  ERROR_FETCHING_USERS: 'ERROR_FETCHING_USERS',

  FETCHING_PERFORMANCE_DATA: 'FETCHING_PERFORMANCE_DATA',
  PERFORMANCE_DATA_FETCHED: 'PERFORMANCE_DATA_FETCHED',
  DATA_ALREADY_EXISTS: 'DATA_ALREADY_EXISTS',
  ERROR_FETCHING_PERFORMANCE_DATA: 'ERROR_FETCHING_PERFORMANCE_DATA',

  CREATING_FRANCHISE: 'CREATING_FRANCHISE',
  FRANCHISE_CREATED: 'FRANCHISE_CREATED',
  ERROR_CREATING_FRANCHISE: 'ERROR_CREATING_FRANCHISE',

  CREATING_CHECKLIST: 'CREATING_CHECKLIST',
  CHECKLIST_CREATED: 'CHECKLIST_CREATED',
  ERROR_CREATING_CHECKLIST: 'ERROR_CREATING_CHECKLIST',

  DELETING_CHECKLIST: 'DELETING_CHECKLIST',
  CHECKLIST_DELETED: 'CHECKLIST_DELETED',
  ERROR_DELETING_CHECKLIST: 'ERROR_DELETING_CHECKLIST',

  ADDING_USER_LOCATION: 'ADDING_USER_LOCATION',
  USER_LOCATION_ADDED: 'USER_LOCATION_ADDED',
  ERROR_ADDING_USER_LOCATION: 'ERROR_ADDING_USER_LOCATION',

  REMOVING_USER_LOCATION: 'REMOVING_USER_LOCATION',
  USER_LOCATION_REMOVED: 'USER_LOCATION_REMOVED',
  ERROR_REMOVING_USER_LOCATION: 'ERROR_REMOVING_USER_LOCATION',
  
  DELETING_FRANCHISE: 'DELETING_FRANCHISE',
  FRANCHISE_DELETED: 'FRANCHISE_DELETED',
  ERROR_DELETING_FRANCHISE: 'ERROR_DELETING_FRANCHISE',

  SET_CHARTS: 'SET_CHARTS',

  SET_CALENDAR: 'SET_CALENDAR',

  SET_OVERALL_INFORMATION: 'SET_OVERALL_INFORMATION',

  ADD_PAST_CHECKLISTS: 'ADD_PAST_CHECKLISTS',

  SET_LIMIT_REACHED: 'SET_LIMIT_REACHED',

  SET_FRANCHISES: 'SET_FRANCHISES',

  CLEAR_CHECKLIST: 'CLEAR_CHECKLIST',
}

export default checklistsTypes